import { FC, ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated } from '@/utils/auth';
import { PagesPaths } from '@/enums';

type ProtectedRouteProps = {
  redirectPath?: PagesPaths;
  children?: ReactNode;
};

const ProtectedRoute: FC<ProtectedRouteProps> = ({
  redirectPath = PagesPaths.Login,
  children,
}) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  return children || <Outlet />;
};

export default ProtectedRoute;
